import React from "react";
import { tWithKeyAttr as t } from "../../../../i18nHelper";
import styles from "../../appointmentsPage.module.css";

export type AppointmentViewType = "daily" | "weekly" | "monthly";

interface ITabNavigationProps {
  activeTab: AppointmentViewType;
  onTabChange: (tab: AppointmentViewType) => void;
}

/**
 * Tab Navigation Component - Therapist Version
 *
 * Simple navigation between Daily, Weekly, and Monthly views
 * (No No-Show Predictor or Conflicts Detector - those are admin-only)
 */
const TabNavigation: React.FC<ITabNavigationProps> = ({
  activeTab,
  onTabChange,
}) => {
  const tabs: {
    id: AppointmentViewType;
    labelKey: string;
    icon: string;
  }[] = [
    { id: "daily", labelKey: "APPOINTMENTS_VIEW_DAILY", icon: "📅" },
    { id: "weekly", labelKey: "APPOINTMENTS_VIEW_WEEKLY", icon: "📆" },
    { id: "monthly", labelKey: "APPOINTMENTS_VIEW_MONTHLY", icon: "🗓️" },
  ];

  return (
    <div className={styles.tabNavigation}>
      {tabs.map((tab) => (
        <button
          key={tab.id}
          className={`${styles.tabButton} ${
            activeTab === tab.id ? styles.tabButtonActive : ""
          }`}
          onClick={() => onTabChange(tab.id)}
          aria-selected={activeTab === tab.id}
          role="tab"
        >
          <span className={styles.tabIcon}>{tab.icon}</span>
          <span className={styles.tabLabel}>{t(tab.labelKey)}</span>
        </button>
      ))}
    </div>
  );
};

export default TabNavigation;
